import React from 'react';
import { JOB_FIT_DISCLAIMER } from './jobFit.shared';

type JobFitDisclaimerProps = {
  className?: string;
};

const JobFitDisclaimer: React.FC<JobFitDisclaimerProps> = ({
  className = '',
}) => (
  <div className={`job-fit-legal ${className}`.trim()}>
    <p className="job-fit-disclaimer mb-0">{JOB_FIT_DISCLAIMER}</p>
  </div>
);

export default JobFitDisclaimer;
